import { createTheme } from "@material-ui/core/styles";

const PRIMARY_MAIN = "#FFCA26";
const PRIMARY_LIGHT = "#FFCA2670";
const PRIMARY_DARK = "#ffe8a0";
const PRIMARY_CONTRAST_TEXT = "#091841";

const SECONDARY_MAIN = "#378AEC";
const SECONDARY_LIGHT = "#E0EEFF";
const SECONDARY_DARK = "#378AEC70";
const SECONDARY_CONTRAST_TEXT = "#272E3A";

const ERROR_MAIN = "#EC1C24";
const ERROR_LIGHT = "#F84F06";
const ERROR_DARK = "#FFECB3";
const ERROR_CONTRAST_TEXT = "#E77F06";

// const WARNING_MAIN = "";
// const WARNING_LIGHT = "";
// const WARNING_DARK = "";
// const WARNING_CONTRAST_TEXT = "";

const INFO_MAIN = "#ffffff70";
const INFO_LIGHT = "#828282";
const INFO_DARK = "#FFFEFA";
const INFO_CONTRAST_TEXT = "#d3d3d3";

const SUCCESS_MAIN = "#18B13A";
const SUCCESS_LIGHT = "";
const SUCCESS_DARK = "";
const SUCCESS_CONTRAST_TEXT = "";

const GRAY_50 = "#5E5F77";
const GRAY_100 = "#7E8DB4";
const GRAY_200 = "#F2F2F2";
const GRAY_300 = "#403F3F";
const GRAY_400 = "#4F4F4F";
const GRAY_500 = "#9B9B9B";
const GRAY_600 = "#F4F6FA";
const GRAY_700 = "#7D7D7D";
const GRAY_800 = "#E9E8E8";
const GRAY_900 = "#BDBDBD";
const GRAY_A100 = "#00000000";
const GRAY_A200 = "#E9E8E8";
const GRAY_A400 = "#F7F7F7";
const GRAY_A700 = "#F3F6FB";

const theme = createTheme({
	palette: {
		primary: {
			main: PRIMARY_MAIN,
			light: PRIMARY_LIGHT,
			dark: PRIMARY_DARK,
			contrastText: PRIMARY_CONTRAST_TEXT
		},
		secondary: {
			main: SECONDARY_MAIN,
			light: SECONDARY_LIGHT,
			dark: SECONDARY_DARK,
			contrastText: SECONDARY_CONTRAST_TEXT
		},
		error: {
			main: ERROR_MAIN,
			light: ERROR_LIGHT,
			dark: ERROR_DARK,
			contrastText: ERROR_CONTRAST_TEXT
		},
		// warning: {
		// 	main: WARNING_MAIN,
		// 	light: WARNING_LIGHT,
		// 	dark: WARNING_DARK,
		// 	contrastText: WARNING_CONTRAST_TEXT
		// },
		info: {
			main: INFO_MAIN,
			light: INFO_LIGHT,
			dark: INFO_DARK,
			contrastText: INFO_CONTRAST_TEXT
		},
		success: {
			main: SUCCESS_MAIN,
			light: SUCCESS_LIGHT,
			dark: SUCCESS_DARK,
			contrastText: SUCCESS_CONTRAST_TEXT
		},
		grey: {
			50: GRAY_50,
			100: GRAY_100,
			200: GRAY_200,
			300: GRAY_300,
			400: GRAY_400,
			500: GRAY_500,
			600: GRAY_600,
			700: GRAY_700,
			800: GRAY_800,
			900: GRAY_900,
			A100: GRAY_A100,
			A200: GRAY_A200,
			A400: GRAY_A400,
			A700: GRAY_A700
		}
	}
});

export default theme;
